import { render, staticRenderFns } from "./PersonReligionDataComponent.vue?vue&type=template&id=ca8ceaa8"
import script from "./PersonReligionDataComponent.vue?vue&type=script&lang=js"
export * from "./PersonReligionDataComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports